export default {
    TITLE: 'No internet connection',
    CONTENT: 'You are currently offline. Please, try sharing this comparison when you are online.',
};
